import { render, staticRenderFns } from "./recruitment-fusion-bar-card.vue?vue&type=template&id=8fdad3da&"
import script from "./recruitment-fusion-bar-card.vue?vue&type=script&lang=js&"
export * from "./recruitment-fusion-bar-card.vue?vue&type=script&lang=js&"
import style0 from "./recruitment-fusion-bar-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "recruitment-fusion-bar-card.vue"
export default component.exports